import { getAuthHeader, getError, header } from '../../shared/utils';
import {
  API_ADD_DEVELOPMENT,
  API_EDIT_DEVELOPMENT,
  API_DELETE_DEVELOPMENT,
  API_UPDATE_DEVELOPMENT_STATUS,
} from '../../shared/constant/url';

export const DEVELOPMENT = {
  ADD_START: 'ADD_START',
  ADD_SUCCESS: 'ADD_SUCCESS',
  ADD_ERROR: 'ADD_ERROR',

  DELETE_START: 'DELETE_START',
  DELETE_SUCCESS: 'DELETE_SUCCESS',
  DELETE_ERROR: 'DELETE_ERROR',

  EDIT_START: 'EDIT_START',
  EDIT_SUCCESS: 'EDIT_SUCCESS',
  EDIT_ERROR: 'EDIT_ERROR',

  UPDATE_DEVELOPMENT_START: 'UPDATE_DEVELOPMENT_START',
  UPDATE_DEVELOPMENT_SUCCESS: 'UPDATE_DEVELOPMENT_SUCCESS',
  UPDATE_DEVELOPMENT_ERROR: 'UPDATE_DEVELOPMENT_ERROR',
};

export const addDevelopmentRecord = (params, file, callback = null) => {
  return (dispatch) => {
    dispatch({ type: DEVELOPMENT.ADD_START });
    let formData = new FormData();
    formData.append('report_type', params.category);
    formData.append('date_submitted', params.date_submitted);
    formData.append('subject', params.subject);
    if (params.task_id) {
      formData.append('task_id', params.task_id);
    }
    if (file.length > 0) {
      for (let i = 0; i < file.length; i++) {
        formData.append(`file[${i}]`, file[i]);
      }
    }
    formData.append('description', params.description);

    let requestOptions = {
      method: 'POST',
      headers: getAuthHeader(),
      body: formData,
    };
    fetch(API_ADD_DEVELOPMENT, requestOptions)
      .then((response) => response.json())
      .then((response) => {
        callback(response, null);
        dispatch({
          type: DEVELOPMENT.ADD_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        callback(null, error);
        dispatch({
          type: DEVELOPMENT.ADD_ERROR,
          payload: getError(error),
        });
      });
  };
};
export const ArchiveAll = (params, callback = null) => {
  return (dispatch) => {
    dispatch({ type: DEVELOPMENT.ADD_START });
    let formData = new FormData();

    let requestOptions = {
      method: 'POST',
      headers: getAuthHeader(),
    };
    fetch(
      `${API_ADD_DEVELOPMENT}/archive?report_type=${
        params.report_type ? params.report_type : ''
      }&start_date=${params.start_date ? params.start_date : ''}&end_date=${
        params.end_date ? params.end_date : ''
      }`,
      requestOptions,
    )
      .then((response) => response.json())
      .then((response) => {
        callback(response, null);
        dispatch({
          type: DEVELOPMENT.ADD_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        callback(null, error);
        dispatch({
          type: DEVELOPMENT.ADD_ERROR,
          payload: getError(error),
        });
      });
  };
};

export const editDevelopmentRecord = (params, file, id, callback = null) => {
  return (dispatch) => {
    dispatch({ type: DEVELOPMENT.EDIT_START });
    let formData = new FormData();
    if (params.category) {
      formData.append('report_type', params.category);
    }
    if (params.date_submitted) {
      formData.append('date_submitted', params.date_submitted);
    }
    if (params.subject) {
      formData.append('subject', params.subject);
    }
    if (params.description) {
      formData.append('description', params.description);
    }

    if (file.length > 0) {
      for (let i = 0; i < file.length; i++) {
        formData.append(`file[${i}]`, file[i]);
      }
    }

    formData.append('_method', 'PUT');

    let requestOptions = {
      method: 'POST',
      headers: getAuthHeader(),
      body: formData,
    };
    fetch(`${API_EDIT_DEVELOPMENT}${id}`, requestOptions)
      .then((response) => response.json())
      .then((response) => {
        callback(response, null);
        dispatch({
          type: DEVELOPMENT.EDIT_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        callback(null, error);
        dispatch({
          type: DEVELOPMENT.EDIT_ERROR,
          payload: getError(error),
        });
      });
  };
};

export const deleteDevelopmentRecord = (params, callback = null) => {
  return (dispatch) => {
    dispatch({ type: DEVELOPMENT.DELETE_START });
    let requestOption = {
      method: 'DELETE',
      headers: getAuthHeader(),
    };
    fetch(`${API_DELETE_DEVELOPMENT}${params}`, requestOption)
      .then((response) => response.json())
      .then((response) => {
        callback(response);
        dispatch({
          type: DEVELOPMENT.DELETE_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        callback(error, getError(error));
        dispatch({ type: DEVELOPMENT.DELETE_ERROR, payload: error });
      });
  };
};

export const updateDevelopmentStatus = (params, id, callback = null) => {
  return (dispatch) => {
    dispatch({ type: DEVELOPMENT.UPDATE_DEVELOPMENT_START });
    let data = JSON.stringify({ status: params.status });

    let requestOption = {
      method: 'PATCH',
      body: data,
      headers: header(),
    };
    fetch(`${API_UPDATE_DEVELOPMENT_STATUS}${id}/status`, requestOption)
      .then((response) => response.json())
      .then((response) => {
        callback(response);
        dispatch({
          type: DEVELOPMENT.UPDATE_DEVELOPMENT_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        callback(error, getError(error));
        dispatch({
          type: DEVELOPMENT.UPDATE_DEVELOPMENT_ERROR,
          payload: error,
        });
      });
  };
};
